import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const PlusIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <polygon points="14 6.7 9.3 6.7 9.3 2 6.7 2 6.7 6.7 2 6.7 2 9.3 6.7 9.3 6.7 14 9.3 14 9.3 9.3 14 9.3 14 6.7" />
    </SvgIcon>
  );
};
